// Constants for the simplified Add Idea flow
export const simpleAddIdeaConstants = {
  isShow: true,
  title: "Add a New Idea",
  content:
    "Ideas are potential solutions to hypothesized problems. Let's start with the basics - your idea and who it's for.",
  isLoading: true,
};
